<template>
  <div
    class="flex-column mt-3"
  >
    <Baseloader v-if="loading" />
    <div v-if="!loading && resumeApportRecolteGraine">
      <span
        v-if="resumeApportRecolteGraine.cumulPoidsAuxNormesEnKg !== null && resumeApportRecolteGraine.cumulPoidsAuxNormesEnKg !== 0"
        class="d-flex justify-center chiffre-xxl secondary--text"
      >
        {{ Math.round(resumeApportRecolteGraine.cumulPoidsAuxNormesEnKg / 1000) }} t
      </span>
      <span
        v-else
        class="d-flex justify-center chiffre-xxl secondary--text"
      >
        0 t
      </span>
      <div v-if="resumeApportRecolteGraine.cumulPoidsAuxNormesEnKg !== null && resumeApportRecolteGraine.cumulPoidsAuxNormesEnKg !== 0">
        <v-divider class="mt-8" />
        <div class="d-flex flex-row justify-space-between my-3">
          <span
            v-if="resumeApportRecolteGraine.derniersApports.length === 1"
            class="align-self-center titre-h4 secondary--text"
          >Mon dernier apport</span>
          <span
            v-else
            class="align-self-center titre-h4 secondary--text"
          >Mes {{ resumeApportRecolteGraine.derniersApports.length }} derniers apports</span>
        </div>
        <div
          v-for="(apport, index) in derniersApportsTries"
          :key="index"
          class="d-flex flex-column mb-4"
        >
          <div class="d-flex justify-space-between">
            <span class="align-self-center titre-h4 texte-gris-fonce">
              {{ apport.dateApport | date('dd/MM/yyyy') }}
            </span>
            <span class="align-self-center titre-h4 secondary--text">
              {{ apport.poidsAuxNormesEnKg / 1000 | roundNumber(2) }} t
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="(resumeApportRecolteGraine === null || resumeApportRecolteGraine === undefined) && !loading"
    >
      <div
        class="d-flex
        align-center
        flex-column"
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
      >
        <img
          src="@/assets/no-apport.svg"
          alt="no-apport"
        >
        <div
          class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2"
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
        >
          <span>Gardez un oeil sur les apports à votre coopérative pour la graine sélectionnée</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Baseloader from '@/components/common/base-loader.vue'
import { isBefore } from 'date-fns'
import { orderBy } from 'lodash'

export default {
  name: 'Apports',
  components: {Baseloader},
  props: {
    isUtilisateurAgrial: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      resumeRecolteApportParGraine: 'recolte/resumeRecolteApportParGraine',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),

    resumeApportRecolteGraine () {
      return this.resumeRecolteApportParGraine.poidsTotalLivreAuxNormes && this.resumeRecolteApportParGraine.poidsTotalLivreAuxNormes.length ? this.resumeRecolteApportParGraine.poidsTotalLivreAuxNormes.find(r => r.codeIdaRs3 === this.codeGraineActive) : null
    },
    derniersApportsTries () {      
      return orderBy(this.resumeApportRecolteGraine.derniersApports, ['dateApport', 'poidsNetEnKg'], ['desc', 'desc'])        
    }
  },

  watch: {
    anneeRecolteActive: {
      handler () {
        this.loadApports()
      },
      immediate: true
    },
    codeGraineActive () {
      this.loadApports()
    }
  },

  methods: {
    ...mapActions({
      fetchResumeApportRecolteParGraine: 'recolte/fetchResumeApportRecolteParGraine'
    }),

    loadApports () {
      this.loading = true
      this.fetchResumeApportRecolteParGraine(3)
        .then(() => {
          if (this.resumeApportRecolteGraine && !this.isUtilisateurAgrial) {
            this.consultChecker()
          }
        })
        .finally(() => this.loading = false)
    },

    consultChecker () {
      let apportNotConsulted = 0
      let apports = this.resumeApportRecolteGraine.apports
      let lastConsultation = new Date(this.$cookies.get('LAST_CONSULTATION_DETAIL_RECOLTE_' + this.codeGraineRs3Selected))
      apports.forEach(apport => {
        if (lastConsultation !== null && isBefore(lastConsultation, new Date(apport.dateApport))) {
          apportNotConsulted++
        }
      })
      this.$emit('new-apport-consultation', apportNotConsulted)
    }
  }
  }
</script>
<style lang="scss" scoped>
.text-align-center {
  text-align: center;
}
</style>